import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';

import { PlatterGraphic } from '@eb/eds-iconography';
import { ChangesGraphic } from '@eb/eds-iconography';
import { CopyGraphic } from '@eb/eds-iconography';

export default {
    packageSelectionPrompt: {
        heading: lazyGettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: lazyGettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: lazyGettext('Select Package'),
        graphic: <PlatterGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    nonAdminPrompt: {
        heading: lazyGettext('Create with Eventbrite Professional'),
        secondaryHeading: lazyGettext(
            'In order to create an event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: lazyGettext('Create Event'),
        graphic: <ChangesGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
    copyPackageSelectionPrompt: {
        heading: lazyGettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: lazyGettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: lazyGettext('Select Package'),
        graphic: <PlatterGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    copyNonAdminPrompt: {
        heading: lazyGettext('Copy with Eventbrite Professional'),
        secondaryHeading: lazyGettext(
            'In order to copy this event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: lazyGettext('Copy Event'),
        graphic: <CopyGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
};
